const data = [
  {
    team: 'Country',
    'ioc-code': 'USA',
    gold: 'Gold',
    silver: 'Silver',
    bronze: 'Bronze',
    total: 'Total',
  },
  {
    team: 'US',
    'ioc-code': 'USA',
    gold: 1022,
    silver: 795,
    bronze: 706,
    total: 2523,
  },
  {
    team: 'Russia',
    'ioc-code': 'RUS',
    gold: 395,
    silver: 319,
    bronze: 296,
    total: 1010,
  },
  {
    team: 'UK',
    'ioc-code': 'GBR',
    gold: 263,
    silver: 295,
    bronze: 293,
    total: 851,
  },
  {
    team: 'France',
    'ioc-code': 'FRA',
    gold: 212,
    silver: 241,
    bronze: 263,
    total: 716,
  },
  {
    team: 'Germany',
    'ioc-code': 'DEU',
    gold: 191,
    silver: 194,
    bronze: 230,
    total: 615,
  },
  {
    team: 'Italy',
    'ioc-code': 'ITA',
    gold: 206,
    silver: 178,
    bronze: 193,
    total: 577,
  },
  {
    team: 'China',
    'ioc-code': 'CHN',
    gold: 224,
    silver: 167,
    bronze: 155,
    total: 546,
  },
  {
    team: 'Australia',
    'ioc-code': 'AUS',
    gold: 147,
    silver: 163,
    bronze: 187,
    total: 497,
  },
  {
    team: 'Sweden',
    'ioc-code': 'SWE',
    gold: 145,
    silver: 170,
    bronze: 179,
    total: 494,
  },
  {
    team: 'Hungary',
    'ioc-code': 'HUN',
    gold: 175,
    silver: 147,
    bronze: 169,
    total: 491,
  },
  {
    team: 'Japan',
    'ioc-code': 'JPN',
    gold: 142,
    silver: 136,
    bronze: 161,
    total: 439,
  },
  {
    team: 'Romania',
    'ioc-code': 'ROU',
    gold: 89,
    silver: 94,
    bronze: 121,
    total: 304,
  },
  {
    team: 'Finland',
    'ioc-code': 'FIN',
    gold: 101,
    silver: 85,
    bronze: 117,
    total: 303,
  },
  {
    team: 'Canada',
    'ioc-code': 'CAN',
    gold: 64,
    silver: 102,
    bronze: 136,
    total: 302,
  },
  {
    team: 'Netherlands',
    'ioc-code': 'NLD',
    gold: 85,
    silver: 92,
    bronze: 108,
    total: 285,
  },
];

export default data;
